<template>
  <div class="chat-footer">
    <div
      style="
        align-items: center;
        display: flex;
        justify-content: center;
        color: gray;
        font-size: small;
      "
    >
      {{ $t('chat_box.generated_content_warning') }}
    </div>
    <div class="message-input">
      <div class="input-wrapper">
        <textarea
          ref="messageInput"
          class="custom-input"
          rows="1"
          :placeholder="$t('chat_box.type_message_placeholder')"
          v-model="newMessage"
          @input="autoResize"
          @keydown.enter.exact="send"
          @keydown.enter.shift.exact.stop
        ></textarea>

        <div class="icon-container">
          <b-icon
            icon="arrow-right"
            size="is-medium"
            class="icon-button send"
            :title="$t('chat_box.send')"
            @click.native="send"
          />

          <div v-if="showRegenerate" class="icon-divider"></div>

          <b-icon
            v-if="showRegenerate"
            icon="refresh"
            size="is-medium"
            class="icon-button regenerate"
            :class="{ disabled: disableRegenerate }"
            :title="
              disableRegenerate
                ? $t('chat_box.please_wait')
                : $t('chat_box.regenerate')
            "
            @click.native="onRegenerateClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showRegenerate: {
      type: Boolean,
      default: false,
    },
    disableRegenerate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newMessage: '',
    };
  },
  methods: {
    send(event) {
      if (event) event.preventDefault();
      if (!this.newMessage.trim()) return;
      this.$emit('send', this.newMessage.trim());
      this.newMessage = '';
      this.$nextTick(() => this.autoResize());
      if (this.$refs.messageInput) {
        this.$refs.messageInput.blur();
      }
    },
    autoResize() {
      const el = this.$refs.messageInput;
      if (!el) return;
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    },
    onRegenerateClick() {
      if (this.disableRegenerate) return;
      this.$emit('regenerate');
    },
  },
};
</script>

<style scoped>
.chat-footer {
  flex-shrink: 0;
  padding: 6px 10px 10px;
}

.message-input {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.custom-input {
  display: block;
  width: 100%;
  padding: 8px 120px 8px 10px;
  font-size: 1rem;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  outline: none;
  resize: none;
  overflow-y: auto;
  max-height: 120px;
  min-height: 38px;
  line-height: 1.4;
  font-family: inherit;
  box-sizing: border-box;
  margin: 0;
}

/* New icon wrapper */
.icon-container {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 8px;
  right: 10px;
  gap: 10px;
}

.icon-button {
  cursor: pointer;
  transition: color 0.2s ease;
  color: #555;
}

.icon-button:hover {
  color: #000;
}

.icon-button.regenerate {
  color: rebeccapurple;
}

.icon-button.regenerate:hover {
  color: #4b0082;
}

.icon-divider {
  width: 1.5px;
  height: 28px;
  background-color: #ccc;
}

.icon-button.disabled {
  color: #ccc !important;
  cursor: not-allowed;
  pointer-events: none;
}

.icon-button:hover {
  transform: scale(1.1);
  opacity: 0.85;
}
</style>
